// extracted by mini-css-extract-plugin
export default {"container":"video_container__93cv5","video":"video_video__jVmLr"};